module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c1d6R"))).then(() => parcelRequire('hEqeo'));